import React, { useEffect } from 'react';

interface ResourceHintsProps {
  preloadImages?: string[];
  preconnectDomains?: string[];
}

const ResourceHints: React.FC<ResourceHintsProps> = ({ 
  preloadImages = [], 
  preconnectDomains = [] 
}) => {
  useEffect(() => {
    // Add preconnect hints for external domains
    preconnectDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });

    // Add preload hints for critical images
    preloadImages.forEach(imageSrc => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = imageSrc;
      document.head.appendChild(link);
    });

    // Cleanup function
    return () => {
      // Remove preconnect links
      preconnectDomains.forEach(domain => {
        const existingLink = document.querySelector(`link[href="${domain}"]`);
        if (existingLink) {
          document.head.removeChild(existingLink);
        }
      });

      // Remove preload links
      preloadImages.forEach(imageSrc => {
        const existingLink = document.querySelector(`link[href="${imageSrc}"]`);
        if (existingLink) {
          document.head.removeChild(existingLink);
        }
      });
    };
  }, [preloadImages, preconnectDomains]);

  return null; // This component doesn't render anything
};

export default ResourceHints;
